import script from "./HeaderSubMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderSubMenu.vue?vue&type=script&setup=true&lang=js"

import "./HeaderSubMenu.vue?vue&type=style&index=0&id=c3b6c842&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3b6c842"]])

export default __exports__